'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _set = require('lodash/set');

var _set2 = _interopRequireDefault(_set);

var _changedKeys = require('./changedKeys');

var _changedKeys2 = _interopRequireDefault(_changedKeys);

var _createSchemaBridge = require('./createSchemaBridge');

var _createSchemaBridge2 = _interopRequireDefault(_createSchemaBridge);

var _randomIds = require('./randomIds');

var _randomIds2 = _interopRequireDefault(_randomIds);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BaseForm = function (_Component) {
    (0, _inherits3.default)(BaseForm, _Component);

    function BaseForm() {
        (0, _classCallCheck3.default)(this, BaseForm);

        var _this = (0, _possibleConstructorReturn3.default)(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).apply(this, arguments));

        _this.state = { bridge: (0, _createSchemaBridge2.default)(_this.props.schema), changed: null, changedMap: {}, resetCount: 0 };

        _this.delayId = false;
        _this.randomId = (0, _randomIds2.default)(_this.props.id);

        _this.onReset = _this.reset = _this.onReset.bind(_this);
        _this.onChange = _this.change = _this.onChange.bind(_this);
        _this.onSubmit = _this.submit = _this.onSubmit.bind(_this);

        // TODO: It shouldn't be here
        var getModel = _this.getModel.bind(_this);
        _this.getModel = function () {
            var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            var model = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getModel(mode);
            return mode !== null && _this.props.modelTransform ? _this.props.modelTransform(mode, model) : model;
        };
        return _this;
    }

    (0, _createClass3.default)(BaseForm, [{
        key: 'getChildContext',
        value: function getChildContext() {
            return {
                uniforms: {
                    name: this.getChildContextName(),
                    error: this.getChildContextError(),
                    model: this.getChildContextModel(),
                    state: this.getChildContextState(),
                    schema: this.getChildContextSchema(),
                    onChange: this.getChildContextOnChange(),
                    randomId: this.randomId
                }
            };
        }
    }, {
        key: 'getChildContextName',
        value: function getChildContextName() {
            return [];
        }
    }, {
        key: 'getChildContextError',
        value: function getChildContextError() {
            return this.props.error;
        }
    }, {
        key: 'getChildContextModel',
        value: function getChildContextModel() {
            return this.getModel('form');
        }
    }, {
        key: 'getChildContextState',
        value: function getChildContextState() {
            return {
                changed: !!this.state.changed,
                changedMap: this.state.changedMap,

                label: !!this.props.label,
                disabled: !!this.props.disabled,
                placeholder: !!this.props.placeholder,
                showInlineError: !!this.props.showInlineError
            };
        }
    }, {
        key: 'getChildContextSchema',
        value: function getChildContextSchema() {
            return this.state.bridge;
        }
    }, {
        key: 'getChildContextOnChange',
        value: function getChildContextOnChange() {
            return this.onChange;
        }
    }, {
        key: 'getModel',
        value: function getModel() /* mode */{
            return this.props.model;
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            this.setState(function () {
                return {};
            }, function () {
                return _this2.setState(function () {
                    return { changed: false, changedMap: {} };
                });
            });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref) {
            var schema = _ref.schema;

            if (this.props.schema !== schema) {
                this.setState(function () {
                    return { bridge: (0, _createSchemaBridge2.default)(schema) };
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement('form', this.getNativeFormProps());
        }
    }, {
        key: 'getChangedKeys',
        value: function getChangedKeys(root, valueA, valueB) {
            return (0, _changedKeys2.default)(root, valueA, valueB);
        }
    }, {
        key: 'getNativeFormProps',
        value: function getNativeFormProps() {
            var _props = this.props,
                autosave = _props.autosave,
                autosaveDelay = _props.autosaveDelay,
                disabled = _props.disabled,
                error = _props.error,
                label = _props.label,
                model = _props.model,
                modelTransform = _props.modelTransform,
                onChange = _props.onChange,
                onSubmit = _props.onSubmit,
                onSubmitFailure = _props.onSubmitFailure,
                onSubmitSuccess = _props.onSubmitSuccess,
                placeholder = _props.placeholder,
                schema = _props.schema,
                showInlineError = _props.showInlineError,
                props = (0, _objectWithoutProperties3.default)(_props, ['autosave', 'autosaveDelay', 'disabled', 'error', 'label', 'model', 'modelTransform', 'onChange', 'onSubmit', 'onSubmitFailure', 'onSubmitSuccess', 'placeholder', 'schema', 'showInlineError']);


            return (0, _extends3.default)({}, props, {

                onSubmit: this.onSubmit,

                key: 'reset-' + this.state.resetCount
            });
        }
    }, {
        key: 'onChange',
        value: function onChange(key, value) {
            var _this3 = this;

            // Do not set `changed` before componentDidMount
            if (this.state.changed !== null) {
                this.state.changed = true;
                this.getChangedKeys(key, value, (0, _get2.default)(this.getModel(), key)).forEach(function (key) {
                    return _this3.setState(function (state) {
                        return { changedMap: (0, _set2.default)((0, _cloneDeep2.default)(state.changedMap), key, {}) };
                    });
                });
            }

            if (this.props.onChange) {
                this.props.onChange(key, value);
            }

            // Do not call `onSubmit` before componentDidMount
            if (this.state.changed !== null && this.props.autosave) {
                if (this.delayId) {
                    this.delayId = clearTimeout(this.delayId);
                }

                if (this.props.autosaveDelay > 0) {
                    this.delayId = setTimeout(this.onSubmit, this.props.autosaveDelay);
                } else {
                    this.onSubmit();
                }
            }
        }
    }, {
        key: 'onReset',
        value: function onReset() {
            this.setState(function (state) {
                return { changed: false, changedMap: {}, resetCount: state.resetCount + 1 };
            });
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit(event) {
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }

            return Promise.resolve(this.props.onSubmit && this.props.onSubmit(this.getModel('submit'))).then(this.props.onSubmitSuccess, this.props.onSubmitFailure);
        }
    }]);
    return BaseForm;
}(_react.Component);

BaseForm.displayName = 'Form';
BaseForm.defaultProps = {
    model: {},
    label: true,

    autosave: false,
    autosaveDelay: 0,

    noValidate: true
};
BaseForm.childContextTypes = {
    uniforms: _propTypes2.default.shape({
        name: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,

        error: _propTypes2.default.object,
        model: _propTypes2.default.object.isRequired,

        schema: _propTypes2.default.shape({
            getError: _propTypes2.default.func.isRequired,
            getErrorMessage: _propTypes2.default.func.isRequired,
            getErrorMessages: _propTypes2.default.func.isRequired,
            getField: _propTypes2.default.func.isRequired,
            getInitialValue: _propTypes2.default.func.isRequired,
            getProps: _propTypes2.default.func.isRequired,
            getSubfields: _propTypes2.default.func.isRequired,
            getType: _propTypes2.default.func.isRequired,
            getValidator: _propTypes2.default.func.isRequired
        }).isRequired,

        state: _propTypes2.default.shape({
            changed: _propTypes2.default.bool.isRequired,
            changedMap: _propTypes2.default.object.isRequired,

            label: _propTypes2.default.bool.isRequired,
            disabled: _propTypes2.default.bool.isRequired,
            placeholder: _propTypes2.default.bool.isRequired,
            showInlineError: _propTypes2.default.bool.isRequired
        }).isRequired,

        onChange: _propTypes2.default.func.isRequired,
        randomId: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = BaseForm;
BaseForm.propTypes = process.env.NODE_ENV !== "production" ? {
    error: _propTypes2.default.object,
    model: _propTypes2.default.object,
    schema: _propTypes2.default.any.isRequired,

    modelTransform: _propTypes2.default.func,

    onChange: _propTypes2.default.func,
    onSubmit: _propTypes2.default.func,
    onSubmitFailure: _propTypes2.default.func,
    onSubmitSuccess: _propTypes2.default.func,

    label: _propTypes2.default.bool,
    disabled: _propTypes2.default.bool,
    placeholder: _propTypes2.default.bool,
    showInlineError: _propTypes2.default.bool,

    autosave: _propTypes2.default.bool,
    autosaveDelay: _propTypes2.default.number
} : {};


/*****************
 ** WEBPACK FOOTER
 ** ./~/uniforms/BaseForm.js
 ** module id = ./node_modules/uniforms/BaseForm.js
 ** module chunks = 0
 **/